<template>
<v-autocomplete
  v-model="select"
  :items="items"
  :loading="loading"
  :search-input.sync="search"
  hide-no-data
  no-filter
  return-object

  :menu-props="{ offsetY: true, fixed: true }"
  :label="$t('Standort')"
  :placeholder="placeholder"

  no-data-text="Keine passenden Orte gefunden"
  attach
  @change="change"
  outlined
  filled

  clearable
></v-autocomplete>
</template>

<script>
import { GeocoderFactory, Geocoder } from "./Geocoder";

export default {
  name: "GeocoderAutocompleteOutlined",

  props: [
    "value",
    "placeholder",
    "hide-details"
  ],

  data() {
    return {
      loading: false,
      search: null,
      select: null,
      items: [],
      requestSeq: 0,
      debounceTimer: null
    };
  },

  created() {
    GeocoderFactory().then(geocoder => {
      this.geocoder = geocoder
    });
  },

  watch: {
    search(val) {
      if (!val || !String(val).trim()) {
        this.resetPending();
        this.items = this.select ? [this.select] : [];
        return;
      }

      if (val !== this.select && !(this.select && val === this.select.text)) {
        this.querySelections(val);
      }
    },

    value(val) {
      if (val) {
        this.select = val;
      }
    }
  },

  beforeDestroy() {
    this.resetPending();
  },

  methods: {
    resetPending() {
      this.requestSeq++;
      if (this.debounceTimer != null) {
        clearTimeout(this.debounceTimer);
        this.debounceTimer = null;
      }
      if (this.geocoder) {
        this.geocoder.cancelAutocomplete();
      }
      this.loading = false;
    },

    querySelections(value) {
      this.resetPending();

      if (!this.geocoder) {
        return;
      }

      const seq = this.requestSeq;
      this.loading = true;

      this.debounceTimer = setTimeout(() => {
        this.debounceTimer = null;
        if (seq !== this.requestSeq) {
          return;
        }

        this.geocoder.autocomplete(value).then(items => {
          if (seq !== this.requestSeq) {
            return;
          }
          this.items = items.slice();
        }).catch(err => {
          if (!Geocoder.isCancelled(err) && seq === this.requestSeq) {
            this.items = this.select ? [this.select] : [];
          }
        }).then(() => {
          if (seq === this.requestSeq) {
            this.loading = false;
          }
        });
      }, 150);
    },

    change(o) {
      this.resetPending();
      this.$emit("change", o);
    }
  }
};
</script>
